import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '../constants';
import { API_ROUTES } from '../constants/apiRoutes';
import { WelcomeBonusAvailabilityResponse, WelcomeBonusSelectionPayload } from '../types/bonus';
import { getData, postData } from '../utils/api';

export const useWelcomeBonusAvailability = (enabled = true) =>
  useQuery({
    queryKey: [QUERY_KEYS.welcomeBonusAvailability],
    queryFn: (): Promise<WelcomeBonusAvailabilityResponse> =>
      getData(API_ROUTES.WELCOME_BONUS.AVAILABILITY, undefined, 'crm'),
    enabled,
    staleTime: 30_000,
  });

export const useSelectWelcomeBonus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: WelcomeBonusSelectionPayload): Promise<WelcomeBonusAvailabilityResponse> =>
      postData(API_ROUTES.WELCOME_BONUS.SELECTION, payload, 'crm'),
    onSuccess: (data) => {
      queryClient.setQueryData([QUERY_KEYS.welcomeBonusAvailability], data);
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.firstDepositBonus], refetchType: 'all' });
    },
  });
};
